import commonUtil from '../../../../../utils/commonUtil';

export const ECARDETAILS_LOAD = 'ECARDETAILS_LOAD';
export const ECARDETAILS_LOAD_SUCCESS = ' ECARDETAILS_LOAD_SUCCESS';
export const ECARDETAILS_LOAD_FAIL = ' ECARDETAILS_LOAD_FAIL';

const ECARDDETAILSURL = '/api/EditEvent/EcardDetails';

export function handleGetEventCardDetails(eventID) {
  const payload = {};
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel();
  payload.eventId = eventID;
  return {
    types: [ECARDETAILS_LOAD, ECARDETAILS_LOAD_SUCCESS, ECARDETAILS_LOAD_FAIL],
    promise: client => client.post(ECARDDETAILSURL, { data: (payload) }),
  };
}
